import React from 'react';

/**
 * BrandMark — the DriftAlarm corporate logo: an alarm ring (with the two top
 * ring-accents) around a checkmark. This is the exact inline SVG the authenticated
 * app renders in its nav (`src/components/Navbar.js`); reused here so the public
 * header shows the identical brand mark. Decorative (aria-hidden). Colours are the
 * brand tokens (neon-blue ring + accent-cyan check) with hardcoded fallbacks, so it
 * renders correctly on every public theme even where a token is absent.
 */
export default function BrandMark({ size = 24, className = '' }) {
  return (
    <svg
      className={`brand-mark-svg ${className}`.trim()}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="16" cy="18" r="11" stroke="var(--neon-blue, #00a8ff)" strokeWidth="2.2" />
      <path d="M5 8 L9 4 M27 8 L23 4" stroke="var(--neon-blue, #00a8ff)" strokeWidth="2.2" strokeLinecap="round" />
      <path d="M11 18 L14.5 21.5 L21 14" stroke="var(--accent-cyan, #00d4aa)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
